{
  "salon-details-footer": {
    "text": {
      "contact-salon": "THÔNG TIN LIÊN HỆ",
      "closed": "Đóng cửa",
      "opening-time": "GIỜ MỞ CỬA",
      "salon-location": "VỊ TRÍ TIỆM"
    }
  }
}
